var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4046 2.66667H10.0713V1.33333C10.0713 0.979711 9.93081 0.640573 9.68077 0.390524C9.43072 0.140476 9.09158 0 8.73796 0L4.73796 0C4.38433 0 4.0452 0.140476 3.79515 0.390524C3.5451 0.640573 3.40462 0.979711 3.40462 1.33333V2.66667H0.0712891V4H1.40462V14C1.40462 14.5304 1.61534 15.0391 1.99041 15.4142C2.36548 15.7893 2.87419 16 3.40462 16H10.0713C10.6017 16 11.1104 15.7893 11.4855 15.4142C11.8606 15.0391 12.0713 14.5304 12.0713 14V4H13.4046V2.66667ZM4.73796 1.33333H8.73796V2.66667H4.73796V1.33333ZM10.738 14C10.738 14.1768 10.6677 14.3464 10.5427 14.4714C10.4177 14.5964 10.2481 14.6667 10.0713 14.6667H3.40462C3.22781 14.6667 3.05824 14.5964 2.93322 14.4714C2.80819 14.3464 2.73796 14.1768 2.73796 14V4H10.738V14Z",
    fill: "#014D6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0739 6.66602H4.74057V11.9993H6.0739V6.66602Z",
    fill: "#014D6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73537 6.66602H7.40204V11.9993H8.73537V6.66602Z",
    fill: "#014D6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.e765cd348243daa54fec966cf5685c6a.svg";
export { ForwardRef as ReactComponent };